import { init, setupVueErrorHandler } from "yl-nsm-track";

/**
 * 初始化埋点 SDK
 * - 从环境变量读取应用 ID
 * - 配置上报域名和 SDK 参数
 */
export function trackInit() {
  const appId = Number(process.env.VUE_APP_TRACK_APP_ID);
  init(appId, {
    channelDomain: "https://snssdk.jtjms-br.com",
    sdkScriptUrl: "https://datafinder.jtjms-br.com/minio.byterangers.onpremise.docor.static/vpc-rangers-docorstatic-5.4.0/collect-privity-v5.2.11.js",
    globalProperties: {
      platform: "PC",
    },
  });
}

/**
 * 接入 Vue 错误处理桥接
 * - Vue 2：传入 Vue 构造函数
 * - Vue 3：传入 createApp() 返回的 app 实例
 * @param {object} Vue - Vue 2 构造函数或 Vue 3 app 实例
 */
export function vueErrorHandler(Vue) {
  setupVueErrorHandler(Vue);
}

/**
 * 上报页面浏览（PV）
 * @param {Object} to   - 目标路由对象（vue-router）
 * @param {Object} from - 来源路由对象（vue-router）
 */
export function trackPv(to, from) {
  window.$track?.$pv({
    referrer: from.fullPath,
    page_title: to.meta?.title || to.name || "",
    page_url: to.fullPath,
    page_query: JSON.stringify(to.query),
  });
}

/**
 * 上报自定义事件
 * @param {string} eventCode     - 事件编码
 * @param {Object} [options={}]  - 事件参数
 * @param {string} options.event_name   - （必填）事件名称
 * @param {string} [options.user_id]    - （选填）用户 ID
 * @param {string} [options.user_name]  - （选填）用户名称
 */
export function trackEvent(eventCode, options = {}) {
  let userInfo = {};
  try {
    userInfo = JSON.parse(localStorage.getItem("userInfo"));
  } catch (error) {
    console.error(error);
  }
  window.$track?.$event(eventCode, {
    user_id: userInfo.id || "",
    user_name: userInfo.name || "",
    ...options,
  });
}

/**
 * 上报用户登录
 * @param {string|number} userId - 登录用户 ID
 */
export function trackLogin(userId) {
  window.$track?.$login(userId);
}

/**
 * 上报用户登出
 */
export function trackLoginout() {
  window.$track?.$loginout();
}
